// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__21sqz","logotypeContainer":"Header_logotypeContainer__3A0wY","logotype":"Header_logotype__2YBEl"};